import React, { useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import {
  StyledInsert,
  StyledInsertContent,
  StyledInsertTitle,
  StyledInsertText,
  StyledInsertBtn,
} from '../UniversalServicesStyle';
import './../../KindergartenServices/KindergartenServicesTranslate';
import { Content } from '../../../components/ThemeProvider/ThemeStyle';
import kindergartenServicesBg from '../../../_assets/images/kindergartenServicesBg.png';
import { Box } from '@material-ui/core';
import IntegrationModal from '../../../components/IntegrationModal/IntegrationModal';
import useSimpleModal from '../../../components/_hooks/useSimpleModal';
import { withRouter } from 'react-router-dom';
import {
  enableIntegrationForServices,
  serviceRequestModule
} from '../../ServiceRequest/ServiceRequestDucks';
import { setIntegrationLoading, setIntegrationStatus } from '../../LoginPage/LoginDucks';
import { connect } from 'react-redux';
import { history } from '../../../_helpers/history';
import InsertBtn from '../../KindergartenServices/section/InsertBtn';
import { universal_voucher_services_insert } from './UniversalVoucherServicesItems';

function UniversalVoucherServicesInsert({
  contentWidth,
  kdpGbdflStatus,
  kdpZagsStatus,
  loadingIntegration,
  enableIntegrationForServices,
  setIntegrationStatus,
  setIntegrationLoading
}) {
  const { t, i18n } = useTranslation();
  const isKazakhLangSystem = i18n.language === 'kk';
  const integrationModal = useSimpleModal();
  const [showHelperText, setShowHelperText] = useState(false);
  const pollingTimeoutRef = useRef(null);

  const handleZagsPolling = () => {
    const metadata = integrationModal.data;

    enableIntegrationForServices({
      close: integrationModal.close,
      onStatus: status => {
        if (status === 'PENDING') {
          pollingTimeoutRef.current = setTimeout(() => {
            if (integrationModal.isOpen) {
              handleZagsPolling();
            }
          }, 10000);
        } else if (status === 'VALID') {
          history.push(`/services/create/${metadata.code}`);
        }
      }
    });
  };
  const clearResources = () => {
    clearTimeout(pollingTimeoutRef.current);
    pollingTimeoutRef.current = null;
    setIntegrationStatus(null);
    setIntegrationLoading(false);
  };
  const onZagsAutoFill = () => {
    setShowHelperText(false);
    handleZagsPolling();
  };
  const onDonIntegration = () => {
    setShowHelperText(true);
    clearResources();
  };
  return (
    <StyledInsert>
      <img src={kindergartenServicesBg} alt="" />
      <StyledInsertContent>
        <Content contentWidth={contentWidth}>
          <StyledInsertTitle children={t('kindergarten_insert_org_title')} />
        </Content>
        <Content contentWidth={contentWidth}>
          <StyledInsertText children={t('kindergarten_insert_org_text')} />
        </Content>
        <Content contentWidth={contentWidth}>
          {integrationModal.isOpen && (
            <IntegrationModal
              title="kindergarten_integrationTitle"
              {...integrationModal}
              onDonIntegration={onDonIntegration}
              onZagsInit={onZagsAutoFill}
              loadingIntegration={loadingIntegration}
              helperText={showHelperText}
              kdpGbdflStatus={kdpGbdflStatus}
              kdpZagsStatus={kdpZagsStatus}
              clearResources={clearResources}
              setShowHelperText={setShowHelperText}
            />
          )}
          <Box style={isKazakhLangSystem ? { marginRight: '20px' } : {}}>
            <StyledInsertBtn>
              <InsertBtn
                metadata={universal_voucher_services_insert.universal_voucher_queue_short}
                integrationModal={integrationModal}
              />
            </StyledInsertBtn>
          </Box>
          {/*<Box style={isKazakhLangSystem ? { marginRight: '20px' } : {}}>*/}
          {/*  <StyledInsertBtn>*/}
          {/*    <StyledInsertBtn>*/}
          {/*      <InsertBtn metadata={universal_voucher_services_insert.check_queue_number} />*/}
          {/*    </StyledInsertBtn>*/}
          {/*  </StyledInsertBtn>*/}
          {/*</Box>*/}
        </Content>
      </StyledInsertContent>
    </StyledInsert>
  );
}

export default connect(
  state => ({
    kdpGbdflStatus: state[serviceRequestModule].kdpGbdflStatus,
    kdpZagsStatus: state[serviceRequestModule].kdpZagsStatus,
    loadingIntegration: state[serviceRequestModule].loadingIntegration
  }),
  { enableIntegrationForServices, setIntegrationStatus, setIntegrationLoading }
)(withRouter(UniversalVoucherServicesInsert));
